module.exports = __webpack_public_path__ + "859198d5fda879d50589b8c04200d04d.svg";